import { TranslateMessageType } from '@/locales/en';
const translateMessage: TranslateMessageType = {
  TITLE: 'Pluto HipHop Dept.',
  STUDIO: '錄音室',
  TEAM: '團隊',
  PARTNERS: '合作夥伴',
  TOTAL_SUPPLY: '總量',
  CONNECT: '連接錢包',
  CONFIRM: 'CONFIRM',
  CANCEL: 'CANCEL',
  CONNECT_WALLET: '連接錢包',
  PRESALE: '預售',
  PUBLIC_SALE: '公售',
  COMMING_SOON: 'COMMING SOON',
  AGAIN: 'AGAIN',
  APPROVE: '授權',
  MIGRATE: '更換合約',
  ADDRESS: '錢包地址',
  HEADER_NAV_1: '問與答',
  HEADER_NAV_2: '更換合約',
  HEADER_NAV_3: '鑄造',
  HEADER_NAV_4: 'Trial Version',
  HEADER_NAV_5: 'Pluto Studio',
  HEADER_NAV_6: 'Demily Studio',

  ABOUT_1: '互動式音樂 NFT',
  ABOUT_2: 'NFT 的世界充滿無限的可能性，您可以在 OpenSea 上盡情遊玩 PHHD 互動式音樂NFT！ ',
  ABOUT_3: '鑄造你的 Lil Pluto 並獲得你的專屬 Pluto Studio。 LFG！',

  FOOTER_1: 'Copyright © Pluto HipHop Dept. 2021 - 2022',
  FOOTER_2: 'Contract Address',

  FAQ_1: '步驟一：鑄造一個 Lil Pluto',
  FAQ_2: '獲取您自己的 Lil Pluto NFT，加入 Metaverse 中最大的嘻哈社群。 LFG！',
  FAQ_3: '鑄造',
  FAQ_4: '步驟二：認領 Pluto Studio NFT',
  FAQ_5: '在官方網站上認領您自己的 Studio NFT（僅需要 Gas 費），您已經準備好成為製作人了！',
  FAQ_6: '領取',
  FAQ_7: '步驟三：隨心所欲地玩！',
  FAQ_8: '您可以在官方網站和 Opensea 上暢玩您的 Pluto Studio。',
  FAQ_9: '注意：獨特的音效以及特效取決於您的 NFT 的屬性！ 盡情享受吧！',
  FAQ_10: '遊玩',

  HOME_1: 'Lil Pluto NFT',
  HOME_2: 'Pluto Studio',
  HOME_3: 'PHHD - Pluto Studio',
  HOME_4: '首創互動式音樂 NFT！',
  HOME_5: '您將成為音樂製作人，創造最棒的的 beat，並根據您的 Lil Pluto，獲得獨一無二的互動式音樂 NFT！',
  HOME_6: 'Succeed',
  HOME_7: 'Address',
  HOME_8: '輸入您的 Lil Pluto NFT 編號',
  HOME_9: '例如，如果您的 Lil Pluto ID 是 #123，請輸入 123 進行認領',
  HOME_10: '進入 Studios',
  HOME_11: 'Pluto Studio',
  HOME_12: 'Trial Version',
  HOME_13: 'Pluto Studio',
  HOME_14: 'Holders Only',
  HOME_15: 'Demily Studio',
  HOME_16: 'Coming Soon',
  HOME_17: '路線圖',
  HOME_18: '2021 年 09 月',
  HOME_19: 'Lil Pluto 首波發售 ',
  HOME_20: 'Pluto Hiphop Dept. NFT 於 2021 年 9 月發布。',
  HOME_21: 'Lil Pluto 是進入 PHHD Metaverse 的主要角色。將來 Lil Pluto 持有者將會有更多的專屬福利。',
  HOME_22: '2021 年 10 月',
  HOME_23: 'Lil Gecko 贈送',
  HOME_24: '領取',
  HOME_25: '為感謝早期支持者，Lil Gecko 可以免費領取。 （僅限於 2021 年第一批 Holder） ',
  HOME_26: '2022 年 02 月',
  HOME_27: '互動式音樂 NFT',
  HOME_28: '互動式音樂 NFT 經過半年的技術研究、人員補強， PHHD 將為所有 Lil Pluto 持有者提供專屬的互動式音樂 NFT。 Lil Pluto NFT 的不同屬性會有各自對應的音樂元素，而這或許是世界上第一款可以在 OpenSea 上透過鍵盤演奏的音樂 NFT。希望以此凝聚更多喜愛嘻哈、喜愛創作的夥伴，並建立起更大的社群！',
  HOME_29: '2022 Q2',
  HOME_30: '音樂拓展',
  HOME_31: 'PHHD 將創造更多獨特的旋律和樂器聲音，針對粉絲提供更近一步的音樂饗宴。持有者可以將自己的循環合成為一首完整的歌曲甚至是一張專輯。讓你自己的音樂 NFT 更有價值和更有意義的收藏。',

  MIGRATE_0: '更換合約',
  MIGRATE_1: '由於 NFT 的快速發展以及更高效優質的合約出現，PHHD 決定進行換約，以節省未來的鑄造費，同時減少 Lil Pluto 的總供應量。',
  MIGRATE_2: '如果您是早期支持者，可以通過換約功能燒掉原版的 Lil Pluto，鑄造出相同屬性的Lil Pluto。',
  MIGRATE_3: '由於持有者必須擁有一個新的 Lil Pluto 才能免費領取 Pluto Studio，我們強烈建議所有 Genesis 持有者執行換約功能以享受未來的所有福利。',
  MIGRATE_4: '我們強烈建議所有 Genesis 持有者執行換約功能以享受未來的所有福利。',
  MIGRATE_5: '為了保障所有早期支持者的權益',
  MIGRATE_7: '我們將在新合約中將總供應量從 10,000 減少到 3,333，',
  MIGRATE_8: '以使 Lil Pluto NFT 更加稀有，預售價格為 0.06 ETH，公開發售價格是 0.08 ETH，價格高於 Genesis 鑄造費 0.05 ETH，所有早期支持者都可以在預售和公開發售前獲得專屬的 Pluto Studio 並且遊玩！',
  MIGRATE_9: 'Enter your Lil Pluto #ID',
  MIGRATE_10: 'Step 1. 授權',
  MIGRATE_11: 'Step 2. 更換合約',

  STUDIO_1: '如何遊玩 Studio',
  STUDIO_2: '選擇一個最炸的鼓組',
  STUDIO_3: '選擇一段最屌的旋律',
  STUDIO_4: '用單音、特效開始你的 FreeStyle',
  STUDIO_5: '取得您的 Pluto 以獲得專屬特效！！',
  STUDIO_6: '按下空白鍵重置',
  STUDIO_8: '教學影片',

  STUDIO_10: '在 BARS 之間放置一些 Adlibs。',
  STUDIO_11: '您可以使用的 Ad-libs 取決於 Lil Pluto',
  STUDIO_12: '你擁有的 NFT，去搶你最喜歡的吧！',
  STUDIO_13: '使用酷炫的合成器添加您的標誌性旋律。',

  GECKO_1: '330 個 Lil Pluto 持有者的獨特 Lil Gecko',
  GECKO_2: '免費索取！！',
  GECKO_3: '準備好給你的 Lil Pluto 一個可愛的寵物了嗎？',
  GECKO_4: '認識 PHHD Metaverse 的新成員 - Lil Gecko！',
  GECKO_5: 'Lil Gecko 可供 Lil Pluto 持有者從第一波空頭中獲得',
  GECKO_6: '每個 Lil Pluto 可以領取一隻 Lil Gecko。',
  GECKO_7: 'Lil Gecko 的最大供應量僅為 330 並且不會增加。',
  GECKO_8: '在下方輸入您的 Lil Pluto ID 以領取您的 Lil Gecko！',
  GECKO_9: '例如，如果您的 Lil Pluto ID 是 #123，請輸入 123 進行認領',

};

export default translateMessage;
